<div class="ds-shell" dir="rtl">

  <!-- ══ Topbar ═══════════════════════════════════════════════════════════════ -->
  <header class="ds-topbar">

    <div class="ds-topbar__start">
      <div class="ds-topbar__brand" [routerLink]="['/']">sale<span>4</span>all</div>
      <div class="ds-topbar__sep"></div>
      <div class="ds-topbar__crumb">
        <span class="ds-topbar__crumb-parent" [routerLink]="['/personal/my-ads']">אזור אישי</span>
        <i class="mdi mdi-chevron-left ds-topbar__chevron"></i>
        <span class="ds-topbar__crumb-current">לוח בקרה</span>
      </div>
    </div>

    <div class="ds-topbar__end">
      @if (!loading) {
        <span class="ds-tier-pill ds-tier-pill--{{ subscriptionClass() }}">
          <i class="fas fa-crown"></i> {{ subscriptionLabel() }}
        </span>
      }
      @if (hasSubscription && !loading) {
        <a [routerLink]="['/publish']" class="ds-btn ds-btn--cta">
          <i class="mdi mdi-plus"></i> מודעה חדשה
        </a>
      }
      <a aria-label="חזרה למודעות שלי" [routerLink]="['/personal/my-ads']" class="ds-btn ds-btn--ghost">
        <i class="mdi mdi-arrow-right"></i>
      </a>
    </div>

  </header>

  <!-- ══ Layout ════════════════════════════════════════════════════════════════ -->
  <div class="ds-layout">

    <!-- ── Sidebar ──────────────────────────────────────────────────────────── -->
    <aside class="ds-sidebar">

      <!-- Profile block -->
      @if (!loading) {
        <div class="ds-sidebar__profile">
          <div class="ds-avatar-wrap">
            <app-images-box [selectClass]="'personal-area'" [imageSelected]="userInfo.avatar"></app-images-box>
          </div>
          <div class="ds-sidebar__profile-info">
            <p class="ds-sidebar__name">{{ userInfo.first_name }} {{ userInfo.last_name }}</p>
            <p class="ds-sidebar__phone">{{ userInfo.mainPhone }}</p>
          </div>
        </div>
      }

      <!-- Subscription badge -->
      @if (!loading && hasSubscription) {
        <div class="ds-sidebar__sub">
          <div class="ds-sub-card ds-sub-card--{{ subscriptionClass() }}">
            <i class="fas fa-crown ds-sub-card__icon"></i>
            <div>
              <div class="ds-sub-card__label">החבילה שלך</div>
              <div class="ds-sub-card__tier">{{ subscriptionLabel() }}</div>
            </div>
          </div>
        </div>
      }

      <!-- Nav -->
      <nav class="ds-nav">
        <p class="ds-nav__section-label">ניהול</p>
        <a class="ds-nav__item ds-nav__item--active" [routerLink]="['/personal/vip-dashboard']" routerLinkActive="ds-nav__item--active">
          <i class="mdi mdi-view-dashboard"></i>
          <span>לוח בקרה</span>
        </a>
        <a class="ds-nav__item" [routerLink]="['/personal/my-ads']" routerLinkActive="ds-nav__item--active">
          <i class="mdi mdi-bulletin-board"></i>
          <span>המודעות שלי</span>
          @if (stats.total > 0) {
            <span class="ds-nav__badge">{{ stats.total }}</span>
          }
        </a>
        <a class="ds-nav__item" [routerLink]="['/publish']">
          <i class="mdi mdi-plus-circle-outline"></i>
          <span>פרסם מודעה</span>
        </a>

        <p class="ds-nav__section-label" style="margin-top:12px">חשבון</p>
        <a class="ds-nav__item" [routerLink]="['/personal/user-info']" routerLinkActive="ds-nav__item--active">
          <i class="mdi mdi-account-outline"></i>
          <span>פרופיל</span>
        </a>
        <a class="ds-nav__item" [routerLink]="['/personal/wishlist']" routerLinkActive="ds-nav__item--active">
          <i class="mdi mdi-heart-outline"></i>
          <span>רשימת משאלות</span>
        </a>
      </nav>

      <!-- Logout -->
      <a class="ds-sidebar__logout" href="#" (click)="logout()">
        <i class="mdi mdi-logout-variant"></i>
        <span>התנתק</span>
      </a>

    </aside>

    <!-- ── Main ──────────────────────────────────────────────────────────────── -->
    <main class="ds-main">

      <!-- Loading -->
      @if (loading) {
        <div class="ds-loading">
          <div class="ds-spinner"></div>
          <span>טוען נתונים...</span>
        </div>
      }

      @if (!loading) {
        <!-- ═══════════════ UPSELL ════════════════ -->
        @if (!hasSubscription) {
          <div class="ds-upsell">
            <div class="ds-upsell__card">
              <div class="ds-upsell__crown"><i class="fas fa-crown"></i></div>
              <h2 class="ds-upsell__h">שדרג למנוי VIP</h2>
              <p class="ds-upsell__p">קבל גישה ללוח הבקרה המלא, עקוב אחר ביצועי המודעות וקבל חשיפה מוגברת לקהל רחב יותר.</p>
              <a [routerLink]="['/publish']" class="ds-upsell__cta">
                <i class="fas fa-bolt"></i>&nbsp; בחר חבילה
              </a>
              <div class="ds-upsell__features">
                <div class="ds-upsell__feat"><i class="mdi mdi-check"></i> ניתוח ביצועים</div>
                <div class="ds-upsell__feat"><i class="mdi mdi-check"></i> חשיפה מוגברת</div>
                <div class="ds-upsell__feat"><i class="mdi mdi-check"></i> ניהול מתקדם</div>
                <div class="ds-upsell__feat"><i class="mdi mdi-check"></i> תמיכה עדיפה</div>
              </div>
            </div>
            <!-- Ghost preview -->
            <div class="ds-upsell__preview">
              <div class="ds-upsell__preview-overlay">
                <i class="fas fa-lock"></i>
                <span>זמין למנויים בלבד</span>
              </div>
              <div class="ds-ghost-grid">
                @for (n of [1,2,3,4]; track n) {
                  <div class="ds-ghost-kpi"></div>
                }
              </div>
              <div class="ds-ghost-row"></div>
              <div class="ds-ghost-row ds-ghost-row--short"></div>
            </div>
          </div>
        }
        <!-- ═══════════════ DASHBOARD ════════════════ -->
        @if (hasSubscription) {
          <!-- Page heading -->
          <div class="ds-page-head">
            <div>
              <h1 class="ds-page-head__title">שלום, {{ userInfo.first_name }} 👋</h1>
              <p class="ds-page-head__sub">הנה סיכום הפעילות שלך</p>
            </div>
            <div class="ds-page-head__actions">
              <a [routerLink]="['/personal/my-ads']" class="ds-btn ds-btn--secondary">
                <i class="mdi mdi-bulletin-board"></i> נהל מודעות
              </a>
              <a [routerLink]="['/publish']" class="ds-btn ds-btn--primary">
                <i class="mdi mdi-plus"></i> מודעה חדשה
              </a>
            </div>
          </div>
          <!-- KPI row -->
          <div class="ds-kpi-row">
            <div class="ds-kpi ds-kpi--purple">
              <div class="ds-kpi__body">
                <span class="ds-kpi__label">מכסת פרסום</span>
                <span class="ds-kpi__value">{{ quotaLabel() }}</span>
                @if (quotaDetail()) {
                  <span class="ds-kpi__sub">{{ quotaDetail() }}</span>
                }
              </div>
              <div class="ds-kpi__icon-wrap">
                <i class="mdi mdi-gauge"></i>
              </div>
            </div>
            <div class="ds-kpi ds-kpi--blue">
              <div class="ds-kpi__body">
                <span class="ds-kpi__label">סה"כ מודעות</span>
                <span class="ds-kpi__value">{{ stats.total }}</span>
              </div>
              <div class="ds-kpi__icon-wrap">
                <i class="mdi mdi-bulletin-board"></i>
              </div>
            </div>
            <div class="ds-kpi ds-kpi--green">
              <div class="ds-kpi__body">
                <span class="ds-kpi__label">פעילות</span>
                <span class="ds-kpi__value">{{ stats.active }}</span>
              </div>
              <div class="ds-kpi__icon-wrap">
                <i class="mdi mdi-check-circle-outline"></i>
              </div>
            </div>
            <div class="ds-kpi ds-kpi--amber">
              <div class="ds-kpi__body">
                <span class="ds-kpi__label">בבדיקה</span>
                <span class="ds-kpi__value">{{ stats.inReview }}</span>
              </div>
              <div class="ds-kpi__icon-wrap">
                <i class="mdi mdi-clock"></i>
              </div>
            </div>
            <div class="ds-kpi ds-kpi--orange">
              <div class="ds-kpi__body">
                <span class="ds-kpi__label">מושהות</span>
                <span class="ds-kpi__value">{{ stats.paused }}</span>
              </div>
              <div class="ds-kpi__icon-wrap">
                <i class="mdi mdi-pause-circle-outline"></i>
              </div>
            </div>
            <div class="ds-kpi ds-kpi--red">
              <div class="ds-kpi__body">
                <span class="ds-kpi__label">לא פעילות</span>
                <span class="ds-kpi__value">{{ stats.expired }}</span>
              </div>
              <div class="ds-kpi__icon-wrap">
                <i class="mdi mdi-close-circle-outline"></i>
              </div>
            </div>
          </div>
          <!-- SCRUM-267: business performance -->
          <app-business-performance [ads]="adOptions"></app-business-performance>
          <!-- Charts row -->
          <div class="ds-charts-row">
            <!-- Monthly bar chart -->
            @if (monthlyData.length > 0) {
              <div class="ds-card ds-chart-bar-card">
                <div class="ds-card__head">
                  <div class="ds-card__title">
                    <i class="mdi mdi-chart-bar"></i> פעילות חודשית
                  </div>
                  <span class="ds-card__badge">6 חודשים אחרונים</span>
                </div>
                <div class="ds-bar-chart">
                  @for (m of monthlyData; track m) {
                    <div class="ds-bar-item">
                      <div class="ds-bar-col">
                        <span class="ds-bar-count">{{ m.count }}</span>
                        <div class="ds-bar-track">
                          <div class="ds-bar-fill"
                            [style.height.%]="(m.count / maxMonthlyCount) * 100">
                          </div>
                        </div>
                      </div>
                      <span class="ds-bar-label">{{ m.month }}</span>
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Category breakdown -->
            @if (categoryStats.length > 0) {
              <div class="ds-card ds-chart-cat-card">
                <div class="ds-card__head">
                  <div class="ds-card__title">
                    <i class="mdi mdi-shape-outline"></i> פילוח קטגוריות
                  </div>
                </div>
                <div class="ds-cat-list">
                  @for (c of categoryStats; track c) {
                    <div class="ds-cat-row">
                      <div class="ds-cat-icon-wrap">
                        <i class="fas {{ c.icon }}"></i>
                      </div>
                      <div class="ds-cat-info">
                        <div class="ds-cat-top">
                          <span class="ds-cat-name">{{ c.label }}</span>
                          <span class="ds-cat-count">{{ c.count }} מודעות</span>
                        </div>
                        <div class="ds-cat-track">
                          <div class="ds-cat-fill" [style.width.%]="c.percent"></div>
                        </div>
                      </div>
                      <span class="ds-cat-pct">{{ c.percent }}%</span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <!-- Recent ads -->
          <div class="ds-card ds-ads-card">
            <div class="ds-card__head">
              <div class="ds-card__title">
                <i class="mdi mdi-history"></i> מודעות אחרונות
              </div>
              <a [routerLink]="['/personal/my-ads']" class="ds-card__link">
                הצג הכל <i class="mdi mdi-arrow-left"></i>
              </a>
            </div>
            <!-- Empty -->
            @if (recentAds.length === 0) {
              <div class="ds-empty">
                <i class="mdi mdi-bulletin-board ds-empty__icon"></i>
                <p class="ds-empty__text">עדיין לא פרסמת מודעות</p>
                <a [routerLink]="['/publish']" class="ds-btn ds-btn--primary ds-btn--sm">פרסם עכשיו</a>
              </div>
            }
            <!-- Table -->
            @if (recentAds.length > 0) {
              <div class="ds-table">
                <div class="ds-table__head">
                  <span class="ds-th ds-th--ad">מודעה</span>
                  <span class="ds-th">מחיר</span>
                  <span class="ds-th">נוצר</span>
                  <span class="ds-th">סטטוס</span>
                  <span class="ds-th ds-th--action"></span>
                </div>
                @for (ad of recentAds; track ad) {
                  <div class="ds-table__row" (click)="openAdDialog(ad)">
                    <div class="ds-td ds-td--ad">
                      <img class="ds-ad-thumb" [src]="imgUrl(ad)" [alt]="ad.name"
                        (error)="$any($event.target).src='assets/imgs/placeholder.png'">
                        <div class="ds-ad-text">
                          <span class="ds-ad-name">{{ ad.name }}</span>
                          @if (ad.adsRoute?.title) {
                            <span class="ds-ad-pkg">{{ ad.adsRoute.title }}</span>
                          }
                        </div>
                      </div>
                      <div class="ds-td">
                        @if (ad.price) {
                          <span class="ds-price">₪{{ ad.price | number }}</span>
                        }
                        @if (!ad.price) {
                          <span class="ds-dash">—</span>
                        }
                      </div>
                      <div class="ds-td ds-td--date">{{ timeAgo(ad.createTime) }}</div>
                      <div class="ds-td">
                        <span class="ds-badge ds-badge--{{ statusClass(ad.statusAds) }}">{{ statusLabel(ad.statusAds) }}</span>
                      </div>
                      <div class="ds-td ds-td--action" (click)="$event.stopPropagation()">
                        <button class="ds-icon-btn" (click)="openAdDialog(ad)" title="פתח">
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            <!-- Quick actions -->
            <div class="ds-quick-grid">
              <div class="ds-quick" [routerLink]="['/publish']">
                <div class="ds-quick__icon ds-quick__icon--green"><i class="mdi mdi-plus-circle-outline"></i></div>
                <span class="ds-quick__label">פרסם מודעה</span>
                <i class="mdi mdi-arrow-left ds-quick__arrow"></i>
              </div>
              <div class="ds-quick" [routerLink]="['/personal/my-ads']">
                <div class="ds-quick__icon ds-quick__icon--blue"><i class="mdi mdi-pencil-box-outline"></i></div>
                <span class="ds-quick__label">ערוך מודעות</span>
                <i class="mdi mdi-arrow-left ds-quick__arrow"></i>
              </div>
              <div class="ds-quick" [routerLink]="['/personal/user-info']">
                <div class="ds-quick__icon ds-quick__icon--purple"><i class="mdi mdi-account-settings"></i></div>
                <span class="ds-quick__label">עדכן פרופיל</span>
                <i class="mdi mdi-arrow-left ds-quick__arrow"></i>
              </div>
              <div class="ds-quick" [routerLink]="['/personal/wishlist']">
                <div class="ds-quick__icon ds-quick__icon--pink"><i class="mdi mdi-heart-outline"></i></div>
                <span class="ds-quick__label">רשימת משאלות</span>
                <i class="mdi mdi-arrow-left ds-quick__arrow"></i>
              </div>
            </div>
          }
        }

      </main>
    </div>
  </div>
